import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface InventoryPositionState {
  top_asins: string;
  seller_id: string;
}

export const initialState: InventoryPositionState = {
  top_asins: "10",
  seller_id: "",
};

export const inventoryPositionSlice = createSlice({
  name: "inventoryPosition",
  initialState,
  reducers: {
    changeTopAsins: (
      state: InventoryPositionState,
      action: PayloadAction<string>
    ) => {
      state.top_asins = action.payload;
    },
    changeSellerIdInventoryPosition: (
      state: InventoryPositionState,
      action: PayloadAction<string>
    ) => {
      state.seller_id = action.payload;
    },
  },
});

export const { changeTopAsins, changeSellerIdInventoryPosition } =
  inventoryPositionSlice.actions;
